import React from 'react';
import { ActionIcon, ActionIconProps, Button, ButtonProps } from '@mantine/core';
import styles from './PrimaryButton.module.scss'; // Importing CSS Module

interface PrimaryButtonProps extends ButtonProps {
    label?: string;
    Icon?: any;
    iconColor?: string;
    onClick?: () => void;
    disabled?: boolean;
    variant?: 'primary' | 'pill' | 'secondary' | 'pdf';
}


export const PrimaryButton = ({ label, Icon, iconColor = '#fff', onClick, disabled, variant = 'primary', ...rest }: PrimaryButtonProps) => {
    return (
        <Button
            className={styles[variant]}
            onClick={onClick}
            disabled={disabled}
            rightSection={Icon ? <Icon size={24} color={iconColor} /> : null}
            // fullWidth
            {...rest}
        >
            {label && <span className={styles.buttonLabel}>{label}</span>}
        </Button>
    );
};

interface IconButtonProps extends ActionIconProps {
    Icon?: any;
    onClick?: () => void;
    disabled?: boolean;
    variant?: 'menu' | 'float' | 'chrome';
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
    ({ Icon, onClick, disabled, variant = 'menu', ...rest }, ref) => {
        // `chrome` is a ghost icon on the navy bar — let Mantine paint nothing so
        // our transparent CSS wins; the filled variants keep their solid fill.
        const mantineVariant = variant === 'chrome' ? 'transparent' : 'filled';
        return (
            <ActionIcon
                ref={ref}
                className={styles[variant]}
                onClick={onClick}
                disabled={disabled}
                variant={mantineVariant}
                {...rest}
            >
                {Icon && <Icon size={24} color="#fff" />}
            </ActionIcon>
        );
    }
);
